// removed by extract-text-webpack-plugin
module.exports = {"disclaimer":"_3c1UK6Z_sTi2gKpOWH4zfT"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/disclaimer/EasinsureDisclaimer.scss
// module id = 1168
// module chunks = 0